__turbopack_context__.v({
  "container": "ShowMore-module-scss-module__1RAeeq__container",
  "expanded": "ShowMore-module-scss-module__1RAeeq__expanded",
  "moreButton": "ShowMore-module-scss-module__1RAeeq__moreButton",
});
